export const LOGIN_REQUEST = 'LOGIN_REQUEST'
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const LOGIN_FAIL = 'LOGIN_FAIL'

export const VERIFY_OTP_REQUEST = 'VERIFY_OTP_REQUEST'
export const VERIFY_OTP_SUCCESS = 'VERIFY_OTP_SUCCESS'
export const VERIFY_OTP_FAIL = 'VERIFY_OTP_FAIL'

export const RESEND_OTP_REQUEST = 'RESEND_OTP_REQUEST'
export const RESEND_OTP_SUCCESS = 'RESEND_OTP_SUCCESS'
export const RESEND_OTP_FAIL = 'RESEND_OTP_FAIL'

export const GET_SURVEY_REQUEST = 'GET_SURVEY_REQUEST'
export const GET_SURVEY_SUCCESS = 'GET_SURVEY_SUCCESS'
export const GET_SURVEY_FAIL = 'GET_SURVEY_FAIL'

export const GET_SURVEY_LIST_DATA_REQUEST = 'GET_SURVEY_LIST_DATA_REQUEST'
export const GET_SURVEY_LIST_DATA_SUCCESS = 'GET_SURVEY_LIST_DATA_SUCCESS'
export const GET_SURVEY_LIST_DATA_FAIL = 'GET_SURVEY_LIST_DATA_FAIL'

export const ADD_SURVEY_REQUEST = 'ADD_SURVEY_REQUEST'
export const ADD_SURVEY_SUCCESS = 'ADD_SURVEY_SUCCESS'
export const ADD_SURVEY_FAIL = 'ADD_SURVEY_FAIL'

export const DELETE_SURVEY_REQUEST = 'DELETE_SURVEY_REQUEST'
export const DELETE_SURVEY_SUCCESS = 'DELETE_SURVEY_SUCCESS'
export const DELETE_SURVEY_FAIL = 'DELETE_SURVEY_FAIL'

export const DUPLICATE_SURVEY_REQUEST = 'DUPLICATE_SURVEY_REQUEST'
export const DUPLICATE_SURVEY_SUCCESS = 'DUPLICATE_SURVEY_SUCCESS'
export const DUPLICATE_SURVEY_FAIL = 'DUPLICATE_SURVEY_FAIL'

export const MOVE_TO_DRAFT_SURVEY_REQUEST = 'MOVE_TO_DRAFT_SURVEY_REQUEST'
export const MOVE_TO_DRAFT_SURVEY_SUCCESS = 'MOVE_TO_DRAFT_SURVEY_SUCCESS'
export const MOVE_TO_DRAFT_SURVEY_FAIL = 'MOVE_TO_DRAFT_SURVEY_FAIL'

export const MOVE_TO_PUBLISH_SURVEY_REQUEST = 'MOVE_TO_PUBLISH_SURVEY_REQUEST'
export const MOVE_TO_PUBLISH_SURVEY_SUCCESS = 'MOVE_TO_PUBLISH_SURVEY_SUCCESS'
export const MOVE_TO_PUBLISH_SURVEY_FAIL = 'MOVE_TO_PUBLISH_SURVEY_FAIL'

export const CLEAR_SURVEY_FORM_DATA = 'CLEAR_SURVEY_FORM_DATA'
export const CHANGE_ADD_SURVEY_FORM_DATA = 'CHANGE_ADD_SURVEY_FORM_DATA'

//Custom Variable
export const ADD_CUSTOM_VARIABLE_REQUEST = 'ADD_CUSTOM_VARIABLE_REQUEST'
export const ADD_CUSTOM_VARIABLE_SUCCESS = 'ADD_CUSTOM_VARIABLE_SUCCESS'
export const ADD_CUSTOM_VARIABLE_FAIL = 'ADD_CUSTOM_VARIABLE_FAIL'

export const GET_CUSTOM_VARIABLE_REQUEST = 'GET_CUSTOM_VARIABLE_REQUEST'
export const GET_CUSTOM_VARIABLE_SUCCESS = 'GET_CUSTOM_VARIABLE_SUCCESS'
export const GET_CUSTOM_VARIABLE_FAIL = 'GET_CUSTOM_VARIABLE_FAIL'

export const UPDATE_CUSTOM_VARIABLE_REQUEST = 'UPDATE_CUSTOM_VARIABLE_REQUEST'
export const UPDATE_CUSTOM_VARIABLE_SUCCESS = 'UPDATE_CUSTOM_VARIABLE_SUCCESS'
export const UPDATE_CUSTOM_VARIABLE_FAIL = 'UPDATE_CUSTOM_VARIABLE_FAIL'

export const DELETE_CUSTOM_VARIABLE_REQUEST = 'DELETE_CUSTOM_VARIABLE_REQUEST'
export const DELETE_CUSTOM_VARIABLE_SUCCESS = 'DELETE_CUSTOM_VARIABLE_SUCCESS'
export const DELETE_CUSTOM_VARIABLE_FAIL = 'DELETE_CUSTOM_VARIABLE_FAIL'

export const UPDATE_CUSTOM_VARIABLE_STATUS_REQUEST = 'UPDATE_CUSTOM_VARIABLE_STATUS_REQUEST'
export const UPDATE_CUSTOM_VARIABLE_STATUS_SUCCESS = 'UPDATE_CUSTOM_VARIABLE_STATUS_SUCCESS'
export const UPDATE_CUSTOM_VARIABLE_STATUS_FAIL = 'UPDATE_CUSTOM_VARIABLE_STATUS_FAIL'

//Custom Variable Value

export const GET_CUSTOM_VARIABLE_VALUE_LIST_REQUEST = 'GET_CUSTOM_VARIABLE_VALUE_LIST_REQUEST'
export const GET_CUSTOM_VARIABLE_VALUE_LIST_SUCCESS = 'GET_CUSTOM_VARIABLE_VALUE_LIST_SUCCESS'
export const GET_CUSTOM_VARIABLE_VALUE_LIST_FAIL = 'GET_CUSTOM_VARIABLE_VALUE_LIST_FAIL'

export const ADD_CUSTOM_VARIABLE_VALUE_REQUEST = 'ADD_CUSTOM_VARIABLE_VALUE_REQUEST'
export const ADD_CUSTOM_VARIABLE_VALUE_SUCCESS = 'ADD_CUSTOM_VARIABLE_VALUE_SUCCESS'
export const ADD_CUSTOM_VARIABLE_VALUE_FAIL = 'ADD_CUSTOM_VARIABLE_VALUE_FAIL'

export const UPDATE_CUSTOM_VARIABLE_VALUE_REQUEST = 'UPDATE_CUSTOM_VARIABLE_VALUE_REQUEST'
export const UPDATE_CUSTOM_VARIABLE_VALUE_SUCCESS = 'UPDATE_CUSTOM_VARIABLE_VALUE_SUCCESS'
export const UPDATE_CUSTOM_VARIABLE_VALUE_FAIL = 'UPDATE_CUSTOM_VARIABLE_VALUE_FAIL'

export const DELETE_CUSTOM_VARIABLE_VALUE_REQUEST = 'DELETE_CUSTOM_VARIABLE_VALUE_REQUEST'
export const DELETE_CUSTOM_VARIABLE_VALUE_SUCCESS = 'DELETE_CUSTOM_VARIABLE_VALUE_SUCCESS'
export const DELETE_CUSTOM_VARIABLE_VALUE_FAIL = 'DELETE_CUSTOM_VARIABLE_VALUE_FAIL'

//UTM Variable
export const GET_UTM_VARIABLE_REQUEST = 'GET_UTM_VARIABLE_REQUEST'
export const GET_UTM_VARIABLE_SUCCESS = 'GET_UTM_VARIABLE_SUCCESS'
export const GET_UTM_VARIABLE_FAIL = 'GET_UTM_VARIABLE_FAIL'

export const UPDATE_UTM_VARIABLE_REQUEST = 'UPDATE_UTM_VARIABLE_REQUEST'
export const UPDATE_UTM_VARIABLE_SUCCESS = 'UPDATE_UTM_VARIABLE_SUCCESS'
export const UPDATE_UTM_VARIABLE_FAIL = 'UPDATE_UTM_VARIABLE_FAIL'

export const ADD_UTM_VARIABLE_REQUEST = 'ADD_UTM_VARIABLE_REQUEST'
export const ADD_UTM_VARIABLE_SUCCESS = 'ADD_UTM_VARIABLE_SUCCESS'
export const ADD_UTM_VARIABLE_FAIL = 'ADD_UTM_VARIABLE_FAIL'

export const DELETE_UTM_VARIABLE_REQUEST = 'DELETE_UTM_VARIABLE_REQUEST'
export const DELETE_UTM_VARIABLE_SUCCESS = 'DELETE_UTM_VARIABLE_SUCCESS'
export const DELETE_UTM_VARIABLE_FAIL = 'DELETE_UTM_VARIABLE_FAIL'

//Custom Formula
export const GET_CUSTOM_FORMULA_REQUEST = 'GET_CUSTOM_FORMULA_REQUEST'
export const GET_CUSTOM_FORMULA_SUCCESS = 'GET_CUSTOM_FORMULA_SUCCESS'
export const GET_CUSTOM_FORMULA_FAIL = 'GET_CUSTOM_FORMULA_FAIL'

export const ADD_CUSTOM_FORMULA_REQUEST = 'ADD_CUSTOM_FORMULA_REQUEST'
export const ADD_CUSTOM_FORMULA_SUCCESS = 'ADD_CUSTOM_FORMULA_SUCCESS'
export const ADD_CUSTOM_FORMULA_FAIL = 'ADD_CUSTOM_FORMULA_FAIL'

export const UPDATE_CUSTOM_FORMULA_REQUEST = 'UPDATE_CUSTOM_FORMULA_REQUEST'
export const UPDATE_CUSTOM_FORMULA_SUCCESS = 'UPDATE_CUSTOM_FORMULA_SUCCESS'
export const UPDATE_CUSTOM_FORMULA_FAIL = 'UPDATE_CUSTOM_FORMULA_FAIL'

export const DELETE_CUSTOM_FORMULA_REQUEST = 'DELETE_CUSTOM_FORMULA_REQUEST'
export const DELETE_CUSTOM_FORMULA_SUCCESS = 'DELETE_CUSTOM_FORMULA_SUCCESS'
export const DELETE_CUSTOM_FORMULA_FAIL = 'DELETE_CUSTOM_FORMULA_FAIL'

//Stages
export const ADD_STAGE_REQUEST = 'ADD_STAGE_REQUEST'
export const ADD_STAGE_SUCCESS = 'ADD_STAGE_SUCCESS'
export const ADD_STAGE_FAIL = 'ADD_STAGE_FAIL'

export const GET_STAGE_REQUEST = 'GET_STAGE_REQUEST'
export const GET_STAGE_SUCCESS = 'GET_STAGE_SUCCESS'
export const GET_STAGE_FAIL = 'GET_STAGE_FAIL'

export const UPDATE_STAGE_REQUEST = 'UPDATE_STAGE_REQUEST'
export const UPDATE_STAGE_SUCCESS = 'UPDATE_STAGE_SUCCESS'
export const UPDATE_STAGE_FAIL = 'UPDATE_STAGE_FAIL'

export const DELETE_STAGE_REQUEST = 'DELETE_STAGE_REQUEST'
export const DELETE_STAGE_SUCCESS = 'DELETE_STAGE_SUCCESS'
export const DELETE_STAGE_FAIL = 'DELETE_STAGE_FAIL'

//Survey URL
export const GET_SURVEY_URL_REQUEST = 'GET_SURVEY_URL_REQUEST'
export const GET_SURVEY_URL_SUCCESS = 'GET_SURVEY_URL_SUCCESS'
export const GET_SURVEY_URL_FAIL = 'GET_SURVEY_URL_FAIL'

export const ADD_SURVEY_URL_REQUEST = 'ADD_SURVEY_URL_REQUEST'
export const ADD_SURVEY_URL_SUCCESS = 'ADD_SURVEY_URL_SUCCESS'
export const ADD_SURVEY_URL_FAIL = 'ADD_SURVEY_URL_FAIL'

export const UPDATE_SURVEY_URL_REQUEST = 'UPDATE_SURVEY_URL_REQUEST'
export const UPDATE_SURVEY_URL_SUCCESS = 'UPDATE_SURVEY_URL_SUCCESS'
export const UPDATE_SURVEY_URL_FAIL = 'UPDATE_SURVEY_URL_FAIL'

export const DELETE_SURVEY_URL_REQUEST = 'DELETE_SURVEY_URL_REQUEST'
export const DELETE_SURVEY_URL_SUCCESS = 'DELETE_SURVEY_URL_SUCCESS'
export const DELETE_SURVEY_URL_FAIL = 'DELETE_SURVEY_URL_FAIL'

export const UPDATE_SURVEY_URL_STATUS_REQUEST = 'UPDATE_SURVEY_URL_STATUS_REQUEST'
export const UPDATE_SURVEY_URL_STATUS_SUCCESS = 'UPDATE_SURVEY_URL_STATUS_SUCCESS'
export const UPDATE_SURVEY_URL_STATUS_FAIL = 'UPDATE_SURVEY_URL_STATUS_FAIL'

//Survey Groups
export const GET_SURVEY_GROUPS_REQUEST = 'GET_SURVEY_GROUPS_REQUEST'
export const GET_SURVEY_GROUPS_SUCCESS = 'GET_SURVEY_GROUPS_SUCCESS'
export const GET_SURVEY_GROUPS_FAIL = 'GET_SURVEY_GROUPS_FAIL'

export const GET_SURVEY_GROUP_DETAIL_REQUEST = 'GET_SURVEY_GROUP_DETAIL_REQUEST'
export const GET_SURVEY_GROUP_DETAIL_SUCCESS = 'GET_SURVEY_GROUP_DETAIL_SUCCESS'
export const GET_SURVEY_GROUP_DETAIL_FAIL = 'GET_SURVEY_GROUP_DETAIL_FAIL'

export const CREATE_SURVEY_GROUP_REQUEST = 'CREATE_SURVEY_GROUP_REQUEST'
export const CREATE_SURVEY_GROUP_SUCCESS = 'CREATE_SURVEY_GROUP_SUCCESS'
export const CREATE_SURVEY_GROUP_FAIL = 'CREATE_SURVEY_GROUP_FAIL'

export const UPDATE_SURVEY_GROUP_REQUEST = 'UPDATE_SURVEY_GROUP_REQUEST'
export const UPDATE_SURVEY_GROUP_SUCCESS = 'UPDATE_SURVEY_GROUP_SUCCESS'
export const UPDATE_SURVEY_GROUP_FAIL = 'UPDATE_SURVEY_GROUP_FAIL'

export const DELETE_SURVEY_GROUP_REQUEST = 'DELETE_SURVEY_GROUP_REQUEST'
export const DELETE_SURVEY_GROUP_SUCCESS = 'DELETE_SURVEY_GROUP_SUCCESS'
export const DELETE_SURVEY_GROUP_FAIL = 'DELETE_SURVEY_GROUP_FAIL'

//Permissions data
export const SET_LANGUAGE_CODE = 'SET_LANGUAGE_CODE'
export const SET_SURVEY_ID = 'SET_SURVEY_ID'
export const SET_SURVEY_NAME = 'SET_SURVEY_NAME'

//QNA Builder
export const SET_SURVEY_TITLE = 'SET_SURVEY_TITLE'
export const SET_SURVEY_DES = 'SET_SURVEY_DES'

export const GET_SURVEY_DATA_REQUEST = 'GET_SURVEY_DATA_REQUEST'
export const GET_SURVEY_DATA_SUCCESS = 'GET_SURVEY_DATA_SUCCESS'
export const GET_SURVEY_DATA_FAIL = 'GET_SURVEY_DATA_FAIL'

// Privacy Policy
export const GET_PRIVACY_POLICY_REQUEST = 'GET_PRIVACY_POLICY_REQUEST'
export const GET_PRIVACY_POLICY_SUCCESS = 'GET_PRIVACY_POLICY_SUCCESS'
export const GET_PRIVACY_POLICY_FAIL = 'GET_PRIVACY_POLICY_FAIL'
export const SAVE_PRIVACY_POLICY_REQUEST = 'SAVE_PRIVACY_POLICY_REQUEST'
export const SAVE_PRIVACY_POLICY_SUCCESS = 'SAVE_PRIVACY_POLICY_SUCCESS'
export const SAVE_PRIVACY_POLICY_FAIL = 'SAVE_PRIVACY_POLICY_FAIL'

// Cookie Policy
export const GET_COOKIE_POLICY_REQUEST = 'GET_COOKIE_POLICY_REQUEST'
export const GET_COOKIE_POLICY_SUCCESS = 'GET_COOKIE_POLICY_SUCCESS'
export const GET_COOKIE_POLICY_FAIL = 'GET_COOKIE_POLICY_FAIL'
export const SAVE_COOKIE_POLICY_REQUEST = 'SAVE_COOKIE_POLICY_REQUEST'
export const SAVE_COOKIE_POLICY_SUCCESS = 'SAVE_COOKIE_POLICY_SUCCESS'
export const SAVE_COOKIE_POLICY_FAIL = 'SAVE_COOKIE_POLICY_FAIL'
export const TOGGLE_COOKIE_POLICY_REQUEST = 'TOGGLE_COOKIE_POLICY_REQUEST'
export const TOGGLE_COOKIE_POLICY_SUCCESS = 'TOGGLE_COOKIE_POLICY_SUCCESS'
export const TOGGLE_COOKIE_POLICY_FAIL = 'TOGGLE_COOKIE_POLICY_FAIL'

//QNA Section
export const GET_SURVEY_SECTION_DATA_REQUEST = 'GET_SURVEY_SECTION_DATA_REQUEST'
export const GET_SURVEY_SECTION_DATA_SUCCESS = 'GET_SURVEY_SECTION_DATA_SUCCESS'
export const GET_SURVEY_SECTION_DATA_FAIL = 'GET_SURVEY_SECTION_DATA_FAIL'

export const UPDATE_SECTION_TITLE_REQUEST = 'UPDATE_SECTION_TITLE_REQUEST'
export const UPDATE_SECTION_TITLE_SUCCESS = 'UPDATE_SECTION_TITLE_SUCCESS'
export const UPDATE_SECTION_TITLE_FAIL = 'UPDATE_SECTION_TITLE_FAIL'

export const UPDATE_SECTION_DESC_REQUEST = 'UPDATE_SECTION_DESC_REQUEST'
export const UPDATE_SECTION_DESC_SUCCESS = 'UPDATE_SECTION_DESC_SUCCESS'
export const UPDATE_SECTION_DESC_FAIL = 'UPDATE_SECTION_DESC_FAIL'

export const GET_SURVEY_QUESTION_DATA_REQUEST = 'GET_SURVEY_QUESTION_DATA_REQUEST'
export const GET_SURVEY_QUESTION_DATA_SUCCESS = 'GET_SURVEY_QUESTION_DATA_SUCCESS'
export const GET_SURVEY_QUESTION_DATA_FAIL = 'GET_SURVEY_QUESTION_DATA_FAIL'

//Update options
export const UPDATE_QUESTION_REQUEST = 'UPDATE_QUESTION_REQUEST'
export const UPDATE_QUESTION_SUCCESS = 'UPDATE_QUESTION_SUCCESS'
export const UPDATE_QUESTION_FAIL = 'UPDATE_QUESTION_FAIL'

export const UPDATE_QUESTION_TYPE_REQUEST = 'UPDATE_QUESTION_TYPE_REQUEST'
export const UPDATE_QUESTION_TYPE_SUCCESS = 'UPDATE_QUESTION_TYPE_SUCCESS'
export const UPDATE_QUESTION_TYPE_FAIL = 'UPDATE_QUESTION_TYPE_FAIL'

export const UPDATE_QUESTION_TEXT_REQUEST = 'UPDATE_QUESTION_TEXT_REQUEST'
export const UPDATE_QUESTION_TEXT_SUCCESS = 'UPDATE_QUESTION_TEXT_SUCCESS'
export const UPDATE_QUESTION_TEXT_FAIL = 'UPDATE_QUESTION_TEXT_FAIL'

export const UPDATE_QUESTION_HINT_REQUEST = 'UPDATE_QUESTION_HINT_REQUEST'
export const UPDATE_QUESTION_HINT_SUCCESS = 'UPDATE_QUESTION_HINT_SUCCESS'
export const UPDATE_QUESTION_HINT_FAIL = 'UPDATE_QUESTION_HINT_FAIL'

export const UPDATE_QUESTION_CONTROL_REQUEST = 'UPDATE_QUESTION_CONTROL_REQUEST'
export const UPDATE_QUESTION_CONTROL_SUCCESS = 'UPDATE_QUESTION_CONTROL_SUCCESS'
export const UPDATE_QUESTION_CONTROL_FAIL = 'UPDATE_QUESTION_CONTROL_FAIL'

//Section data handling
export const ADD_SECTION_REQUEST = 'ADD_SECTION_REQUEST'
export const ADD_SECTION_SUCCESS = 'ADD_SECTION_SUCCESS'
export const ADD_SECTION_FAIL = 'ADD_SECTION_FAIL'

export const DELETE_SECTION_REQUEST = 'DELETE_SECTION_REQUEST'
export const DELETE_SECTION_SUCCESS = 'DELETE_SECTION_SUCCESS'
export const DELETE_SECTION_FAIL = 'DELETE_SECTION_FAIL'

export const DELETE_SECTION_MERGE_QUESTION_REQUEST = 'DELETE_SECTION_MERGE_QUESTION_REQUEST'
export const DELETE_SECTION_MERGE_QUESTION_SUCCESS = 'DELETE_SECTION_MERGE_QUESTION_SUCCESS'
export const DELETE_SECTION_MERGE_QUESTION_FAIL = 'DELETE_SECTION_MERGE_QUESTION_FAIL'

export const DUPLICATE_SECTION_REQUEST = 'DUPLICATE_SECTION_REQUEST'
export const DUPLICATE_SECTION_SUCCESS = 'DUPLICATE_SECTION_SUCCESS'
export const DUPLICATE_SECTION_FAIL = 'DUPLICATE_SECTION_FAIL'

export const UPDATE_SECTION_ORDERING_REQUEST = 'UPDATE_SECTION_ORDERING_REQUEST'
export const UPDATE_SECTION_ORDERING_SUCCESS = 'UPDATE_SECTION_ORDERING_SUCCESS'
export const UPDATE_SECTION_ORDERING_FAIL = 'UPDATE_SECTION_ORDERING_FAIL'

//Question data handling
export const DELETE_QUESTION_REQUEST = 'DELETE_QUESTION_REQUEST'
export const DELETE_QUESTION_SUCCESS = 'DELETE_QUESTION_SUCCESS'
export const DELETE_QUESTION_FAIL = 'DELETE_QUESTION_FAIL'

export const ADD_QUESTION_REQUEST = 'ADD_QUESTION_REQUEST'
export const ADD_QUESTION_SUCCESS = 'ADD_QUESTION_SUCCESS'
export const ADD_QUESTION_FAIL = 'ADD_QUESTION_FAIL'

export const DUPLICATE_QUESTION_REQUEST = 'DUPLICATE_QUESTION_REQUEST'
export const DUPLICATE_QUESTION_SUCCESS = 'DUPLICATE_QUESTION_SUCCESS'
export const DUPLICATE_QUESTION_FAIL = 'DUPLICATE_QUESTION_FAIL'

export const UPDATE_QUESTION_ORDERING_REQUEST = 'UPDATE_QUESTION_ORDERING_REQUEST'
export const UPDATE_QUESTION_ORDERING_SUCCESS = 'UPDATE_QUESTION_ORDERING_SUCCESS'
export const UPDATE_QUESTION_ORDERING_FAIL = 'UPDATE_QUESTION_ORDERING_FAIL'

//Lead gen variables
export const GET_LEAD_GEN_VARIABLE_REQUEST = 'GET_LEAD_GEN_VARIABLE_REQUEST'
export const GET_LEAD_GEN_VARIABLE_SUCCESS = 'GET_LEAD_GEN_VARIABLE_SUCCESS'
export const GET_LEAD_GEN_VARIABLE_FAIL = 'GET_LEAD_GEN_VARIABLE_FAIL'


//Report module
export const START_EDIT_MODE = 'START_EDIT_MODE'
export const STOP_EDIT_MODE = 'STOP_EDIT_MODE'
export const SET_CURRENT_REPORT = 'SET_CURRENT_REPORT'
export const CLEAR_REPORT_DETAILS = 'CLEAR_REPORT_DETAILS'

export const CREATE_REPORT_REQUEST = 'CREATE_REPORT_REQUEST'
export const CREATE_REPORT_SUCCESS = 'CREATE_REPORT_SUCCESS'
export const CREATE_REPORT_FAIL = 'CREATE_REPORT_FAIL'

export const GET_REPORT_DETAILS_REQUEST = 'GET_REPORT_DETAILS_REQUEST'
export const GET_REPORT_DETAILS_SUCCESS = 'GET_REPORT_DETAILS_SUCCESS'
export const GET_REPORT_DETAILS_FAIL = 'GET_REPORT_DETAILS_FAIL'

export const GET_REPORT_LIST_REQUEST = 'GET_REPORT_LIST_REQUEST'
export const GET_REPORT_LIST_SUCCESS = 'GET_REPORT_LIST_SUCCESS'
export const GET_REPORT_LIST_FAIL = 'GET_REPORT_LIST_FAIL'

export const GET_DEFAULT_REPORT_REQUEST = 'GET_DEFAULT_REPORT_REQUEST'
export const GET_DEFAULT_REPORT_SUCCESS = 'GET_DEFAULT_REPORT_SUCCESS'
export const GET_DEFAULT_REPORT_FAIL = 'GET_DEFAULT_REPORT_FAIL'

export const CHANGE_DEFAULT_REPORT_REQUEST = 'CHANGE_DEFAULT_REPORT_REQUEST'
export const CHANGE_DEFAULT_REPORT_SUCCESS = 'CHANGE_DEFAULT_REPORT_SUCCESS'
export const CHANGE_DEFAULT_REPORT_FAIL = 'CHANGE_DEFAULT_REPORT_FAIL'

export const ADD_REPORT_PAGE_REQUEST = 'ADD_REPORT_PAGE_REQUEST'
export const ADD_REPORT_PAGE_SUCCESS = 'ADD_REPORT_PAGE_SUCCESS'
export const ADD_REPORT_PAGE_FAIL = 'ADD_REPORT_PAGE_FAIL'

export const UPDATE_REPORT_NAME_REQUEST = 'UPDATE_REPORT_NAME_REQUEST'
export const UPDATE_REPORT_NAME_SUCCESS = 'UPDATE_REPORT_NAME_SUCCESS'
export const UPDATE_REPORT_NAME_FAIL = 'UPDATE_REPORT_NAME_FAIL'

export const DELETE_REPORT_PAGE_REQUEST = 'DELETE_REPORT_PAGE_REQUEST'
export const DELETE_REPORT_PAGE_SUCCESS = 'DELETE_REPORT_PAGE_SUCCESS'
export const DELETE_REPORT_PAGE_FAIL = 'DELETE_REPORT_PAGE_FAIL'

export const UPDATE_PAGE_REQUEST = 'UPDATE_PAGE_REQUEST'
export const UPDATE_PAGE_SUCCESS = 'UPDATE_PAGE_SUCCESS'
export const UPDATE_PAGE_FAIL = 'UPDATE_PAGE_FAIL'

export const DELETE_REPORT_REQUEST = 'DELETE_REPORT_REQUEST'
export const DELETE_REPORT_SUCCESS = 'DELETE_REPORT_SUCCESS'
export const DELETE_REPORT_FAIL = 'DELETE_REPORT_FAIL'

export const DUPLICATE_REPORT_REQUEST = 'DUPLICATE_REPORT_REQUEST'
export const DUPLICATE_REPORT_SUCCESS = 'DUPLICATE_REPORT_SUCCESS'
export const DUPLICATE_REPORT_FAIL = 'DUPLICATE_REPORT_FAIL'

export const DUPLICATE_PAGE_REQUEST = 'DUPLICATE_PAGE_REQUEST'
export const DUPLICATE_PAGE_SUCCESS = 'DUPLICATE_PAGE_SUCCESS'
export const DUPLICATE_PAGE_FAIL = 'DUPLICATE_PAGE_FAIL'

export const REORDER_PAGE_REQUEST = 'REORDER_PAGE_REQUEST'
export const REORDER_PAGE_SUCCESS = 'REORDER_PAGE_SUCCESS'
export const REORDER_PAGE_FAIL = 'REORDER_PAGE_FAIL'

//Form builder
export const ADD_FIELD_REQUEST = 'ADD_FIELD_REQUEST'
export const ADD_FIELD_SUCCESS = 'ADD_FIELD_SUCCESS'
export const ADD_FIELD_FAIL = 'ADD_FIELD_FAIL'

export const GET_FIELD_REQUEST = 'GET_FIELD_REQUEST'
export const GET_FIELD_SUCCESS = 'GET_FIELD_SUCCESS'
export const GET_FIELD_FAIL = 'GET_FIELD_FAIL'

export const UPDATE_FIELD_REQUEST = 'UPDATE_FIELD_REQUEST'
export const UPDATE_FIELD_SUCCESS = 'UPDATE_FIELD_SUCCESS'
export const UPDATE_FIELD_FAIL = 'UPDATE_FIELD_FAIL'

export const DELETE_FIELD_REQUEST = 'DELETE_FIELD_REQUEST'
export const DELETE_FIELD_SUCCESS = 'DELETE_FIELD_SUCCESS'
export const DELETE_FIELD_FAIL = 'DELETE_FIELD_FAIL'

export const UPDATE_FIELD_ORDER_REQUEST = 'UPDATE_FIELD_ORDER_REQUEST'
export const UPDATE_FIELD_ORDER_SUCCESS = 'UPDATE_FIELD_ORDER_SUCCESS'
export const UPDATE_FIELD_ORDER_FAIL = 'UPDATE_FIELD_ORDER_FAIL'

export const UPDATE_STATIC_FIELD_ORDER_REQUEST = 'UPDATE_STATIC_FIELD_ORDER_REQUEST'
export const UPDATE_STATIC_FIELD_ORDER_SUCCESS = 'UPDATE_STATIC_FIELD_ORDER_SUCCESS'
export const UPDATE_STATIC_FIELD_ORDER_FAIL = 'UPDATE_STATIC_FIELD_ORDER_FAIL'


//Analytics
export const GET_COMPLETION_ANALYSIS_DATA_REQUEST = 'GET_COMPLETION_ANALYSIS_DATA_REQUEST'
export const GET_COMPLETION_ANALYSIS_DATA_SUCCESS = 'GET_COMPLETION_ANALYSIS_DATA_SUCCESS'
export const GET_COMPLETION_ANALYSIS_DATA_FAIL = 'GET_COMPLETION_ANALYSIS_DATA_FAIL'

export const GET_SURVEYS_REQUEST = 'GET_SURVEYS_REQUEST'
export const GET_SURVEYS_SUCCESS = 'GET_SURVEYS_SUCCESS'
export const GET_SURVEYS_FAIL = 'GET_SURVEYS_FAIL'

export const GET_QUESTION_WISE_ANALYSIS_DATA_REQUEST = 'GET_QUESTION_WISE_ANALYSIS_DATA_REQUEST'
export const GET_QUESTION_WISE_ANALYSIS_DATA_SUCCESS = 'GET_QUESTION_WISE_ANALYSIS_DATA_SUCCESS'
export const GET_QUESTION_WISE_ANALYSIS_DATA_FAIL = 'GET_QUESTION_WISE_ANALYSIS_DATA_FAIL'

export const GET_EXIT_ANALYSIS_DATA_REQUEST = 'GET_EXIT_ANALYSIS_DATA_REQUEST'
export const GET_EXIT_ANALYSIS_DATA_SUCCESS = 'GET_EXIT_ANALYSIS_DATA_SUCCESS'
export const GET_EXIT_ANALYSIS_DATA_FAIL = 'GET_EXIT_ANALYSIS_DATA_FAIL'

export const GET_LEADS_DATA_REQUEST = 'GET_LEADS_DATA_REQUEST'
export const GET_LEADS_DATA_SUCCESS = 'GET_LEADS_DATA_SUCCESS'
export const GET_LEADS_DATA_FAIL = 'GET_LEADS_DATA_FAIL'

export const CLEAR_GRAPH_DATA = 'CLEAR_GRAPH_DATA'

//Roles

export const GET_ROLE_FAIL = 'GET_ROLE_FAIL'
export const GET_ROLE_LIST_DATA_FAIL = 'GET_ROLE_LIST_DATA_FAIL'
export const GET_ROLE_LIST_DATA_REQUEST = 'GET_ROLE_LIST_DATA_REQUEST'
export const GET_ROLE_LIST_DATA_SUCCESS = 'GET_ROLE_LIST_DATA_SUCCESS'
export const GET_ROLE_REQUEST = 'GET_ROLE_REQUEST'
export const GET_ROLE_SUCCESS = 'GET_ROLE_SUCCESS'
export const ADD_ROLE_SUCCESS = 'ADD_ROLE_SUCCESS'
export const ADD_ROLE_FAIL = 'ADD_ROLE_FAIL'
export const ADD_ROLE_REQUEST = 'ADD_ROLE_REQUEST'
export const EDIT_ROLE_SUCCESS = 'EDIT_ROLE_SUCCESS'
export const EDIT_ROLE_FAIL = 'EDIT_ROLE_FAIL'
export const EDIT_ROLE_REQUEST = 'EDIT_ROLE_REQUEST'
export const DELETE_ROLE_SUCCESS = 'DELETE_ROLE_SUCCESS'
export const DELETE_ROLE_FAIL = 'DELETE_ROLE_FAIL'
export const DELETE_ROLE_REQUEST = 'DELETE_ROLE_REQUEST'

//Teams

export const GET_TEAM_FAIL = 'GET_TEAM_FAIL'
export const GET_TEAM_LIST_DATA_FAIL = 'GET_TEAM_LIST_DATA_FAIL'
export const GET_TEAM_LIST_DATA_REQUEST = 'GET_TEAM_LIST_DATA_REQUEST'
export const GET_TEAM_LIST_DATA_SUCCESS = 'GET_TEAM_LIST_DATA_SUCCESS'
export const GET_TEAM_REQUEST = 'GET_TEAM_REQUEST'
export const GET_TEAM_SUCCESS = 'GET_TEAM_SUCCESS'
export const LEAVE_TEAM_SUCCESS = 'LEAVE_TEAM_SUCCESS'
export const LEAVE_TEAM_FAIL = 'LEAVE_TEAM_FAIL'
export const LEAVE_TEAM_REQUEST = 'LEAVE_TEAM_REQUEST'
export const ADD_TEAM_SUCCESS = 'ADD_TEAM_SUCCESS'
export const ADD_TEAM_FAIL = 'ADD_TEAM_FAIL'
export const ADD_TEAM_REQUEST = 'ADD_TEAM_REQUEST'
export const EDIT_TEAM_SUCCESS = 'EDIT_TEAM_SUCCESS'
export const EDIT_TEAM_FAIL = 'EDIT_TEAM_FAIL'
export const EDIT_TEAM_REQUEST = 'EDIT_TEAM_REQUEST'
export const DELETE_TEAM_SUCCESS = 'DELETE_TEAM_SUCCESS'
export const DELETE_TEAM_FAIL = 'DELETE_TEAM_FAIL'
export const DELETE_TEAM_REQUEST = 'DELETE_TEAM_REQUEST'
export const DELETE_TEAM_MEMBER_SUCCESS = 'DELETE_TEAM_MEMBER_SUCCESS'
export const DELETE_TEAM_MEMBER_FAIL = 'DELETE_TEAM_MEMBER_FAIL'
export const DELETE_TEAM_MEMBER_REQUEST = 'DELETE_TEAM_MEMBER_REQUEST'
export const GET_TEAM_DETAIL_REQUEST = 'GET_TEAM_DETAIL_REQUEST'
export const GET_TEAM_DETAIL_SUCCESS = 'GET_TEAM_DETAIL_SUCCESS'
export const GET_TEAM_DETAIL_FAIL = 'GET_TEAM_DETAIL_FAIL'
export const ADD_TEAM_MEMBER_SUCCESS = 'ADD_TEAM_MEMBER_SUCCESS'
export const ADD_TEAM_MEMBER_FAIL = 'ADD_TEAM_MEMBER_FAIL'
export const ADD_TEAM_MEMBER_REQUEST = 'ADD_TEAM_MEMBER_REQUEST'

// users

export const GET_USER_LIST_DATA_FAIL = 'GET_USER_LIST_DATA_FAIL'
export const GET_USER_LIST_DATA_REQUEST = 'GET_USER_LIST_DATA_REQUEST'
export const GET_USER_LIST_DATA_SUCCESS = 'GET_USER_LIST_DATA_SUCCESS'
export const ADD_USER_SUCCESS = 'ADD_USER_SUCCESS'
export const ADD_USER_FAIL = 'ADD_USER_FAIL'
export const ADD_USER_REQUEST = 'ADD_USER_REQUEST'
export const EDIT_USER_SUCCESS = 'EDIT_USER_SUCCESS'
export const EDIT_USER_FAIL = 'EDIT_USER_FAIL'
export const EDIT_USER_REQUEST = 'EDIT_USER_REQUEST'
export const DELETE_USER_SUCCESS = 'DELETE_USER_SUCCESS'
export const DELETE_USER_FAIL = 'DELETE_USER_FAIL'
export const DELETE_USER_REQUEST = 'DELETE_USER_REQUEST'
export const CHANGE_USER_STATUS_SUCCESS = 'CHANGE_USER_STATUS_SUCCESS'
export const CHANGE_USER_STATUS_FAIL = 'CHANGE_USER_STATUS_FAIL'
export const CHANGE_USER_STATUS_REQUEST = 'CHANGE_USER_STATUS_REQUEST'

export const GET_USER_DATA_FAIL = 'GET_USER_DATA_FAIL'
export const GET_USER_DATA_REQUEST = 'GET_USER_DATA_REQUEST'
export const GET_USER_DATA_SUCCESS = 'GET_USER_DATA_SUCCESS'
// Module
export const GET_MODULE_REQUEST = 'GET_MODULE_REQUEST'
export const GET_MODULE_SUCCESS = 'GET_MODULE_SUCCESS'
export const GET_MODULE_FAIL = 'GET_MODULE_FAIL'

// Location
export const GET_COUNTRY_REQUEST = 'GET_COUNTRY_REQUEST'
export const GET_COUNTRY_SUCCESS = 'GET_COUNTRY_SUCCESS'
export const GET_COUNTRY_FAIL = 'GET_COUNTRY_FAIL'
export const GET_REGION_REQUEST = 'GET_REGION_REQUEST'
export const GET_REGION_SUCCESS = 'GET_REGION_SUCCESS'
export const GET_REGION_FAIL = 'GET_REGION_FAIL'
export const GET_TIMEZONE_REQUEST = 'GET_TIMEZONE_REQUEST'
export const GET_TIMEZONE_SUCCESS = 'GET_TIMEZONE_SUCCESS'
export const GET_TIMEZONE_FAIL = 'GET_TIMEZONE_FAIL'
export const GET_COUNTRY_CODES_REQUEST = 'GET_COUNTRY_CODES_REQUEST'
export const GET_COUNTRY_CODES_SUCCESS = 'GET_COUNTRY_CODES_SUCCESS'
export const GET_COUNTRY_CODES_FAIL = 'GET_COUNTRY_CODES_FAIL'

export const GET_LOGIN_USER_REQUEST = 'GET_LOGIN_USER_REQUEST'
export const GET_LOGIN_USER_SUCCESS = 'GET_LOGIN_USER_SUCCESS'
export const GET_LOGIN_USER_FAIL = 'GET_LOGIN_USER_FAIL'

//SETTING MODOULE CONSTANTS
export const GET_SETTING_FAIL = 'GET_SETTING_FAIL'
export const GET_SETTING_LIST_DATA_FAIL = 'GET_SETTING_LIST_DATA_FAIL'
export const GET_SETTING_LIST_DATA_REQUEST = 'GET_SETTING_LIST_DATA_REQUEST'
export const GET_SETTING_LIST_DATA_SUCCESS = 'GET_SETTING_LIST_DATA_SUCCESS'
export const GET_SETTING_REQUEST = 'GET_SETTING_REQUEST'
export const GET_SETTING_SUCCESS = 'GET_SETTING_SUCCESS'
export const ADD_SETTING_SUCCESS = 'ADD_SETTING_SUCCESS'
export const ADD_SETTING_FAIL = 'ADD_SETTING_FAIL'
export const ADD_SETTING_REQUEST = 'ADD_SETTING_REQUEST'
export const EDIT_SETTING_SUCCESS = 'EDIT_SETTING_SUCCESS'
export const EDIT_SETTING_FAIL = 'EDIT_SETTING_FAIL'
export const EDIT_SETTING_REQUEST = 'EDIT_SETTING_REQUEST'
export const DELETE_SETTING_SUCCESS = 'DELETE_SETTING_SUCCESS'
export const DELETE_SETTING_FAIL = 'DELETE_SETTING_FAIL'
export const DELETE_SETTING_REQUEST = 'DELETE_SETTING_REQUEST'


// Eloqua Settings
export const UPDATE_ELOQUA_SETTINGS_REQUEST = 'UPDATE_ELOQUA_SETTINGS_REQUEST';
export const UPDATE_ELOQUA_SETTINGS_SUCCESS = 'UPDATE_ELOQUA_SETTINGS_SUCCESS';
export const UPDATE_ELOQUA_SETTINGS_FAIL = 'UPDATE_ELOQUA_SETTINGS_FAIL';
export const GET_ELOQUA_SETTINGS_FAIL = 'GET_ELOQUA_SETTINGS_FAIL';
export const GET_ELOQUA_SETTINGS_SUCCESS = 'GET_ELOQUA_SETTINGS_SUCCESS';
export const GET_ELOQUA_SETTINGS_REQUEST = 'GET_ELOQUA_SETTINGS_REQUEST';

export const GET_LANGUAGES_REQUEST = "GET_LANGUAGES_REQUEST";
export const GET_LANGUAGES_SUCCESS = "GET_LANGUAGES_SUCCESS";
export const GET_LANGUAGES_FAIL = "GET_LANGUAGES_FAIL";

export const ADD_SURVEY_ASSIGN_TO_REQUEST = "ADD_SURVEY_ASSIGN_TO_REQUEST";
export const ADD_SURVEY_ASSIGN_TO_SUCCESS = "ADD_SURVEY_ASSIGN_TO_SUCCESS";
export const ADD_SURVEY_ASSIGN_TO_FAIL = "ADD_SURVEY_ASSIGN_TO_FAIL";


export const GET_SURVEY_ASSIGN_TO_REQUEST = "GET_SURVEY_ASSIGN_TO_REQUEST";
export const GET_SURVEY_ASSIGN_TO_SUCCESS = "GET_SURVEY_ASSIGN_TO_SUCCESS";
export const GET_SURVEY_ASSIGN_TO_FAIL = "GET_SURVEY_ASSIGN_TO_FAIL";


// Webhook
export const GET_WEBHOOKS_REQUEST = 'GET_WEBHOOKS_REQUEST';
export const GET_WEBHOOKS_SUCCESS = 'GET_WEBHOOKS_SUCCESS';
export const GET_WEBHOOKS_FAIL = 'GET_WEBHOOKS_FAIL';

export const UPDATE_WEBHOOK_REQUEST = 'UPDATE_WEBHOOK_REQUEST';
export const UPDATE_WEBHOOK_SUCCESS = 'UPDATE_WEBHOOK_SUCCESS';
export const UPDATE_WEBHOOK_FAIL = 'UPDATE_WEBHOOK_FAIL';

export const DELETE_WEBHOOK_REQUEST = 'DELETE_WEBHOOK_REQUEST';
export const DELETE_WEBHOOK_SUCCESS = 'DELETE_WEBHOOK_SUCCESS';
export const DELETE_WEBHOOK_FAIL = 'DELETE_WEBHOOK_FAIL';

export const GET_WEBHOOK_EVENTS_REQUEST = 'GET_WEBHOOK_EVENTS_REQUEST';
export const GET_WEBHOOK_EVENTS_SUCCESS = 'GET_WEBHOOK_EVENTS_SUCCESS';
export const GET_WEBHOOK_EVENTS_FAIL = 'GET_WEBHOOK_EVENTS_FAIL';

export const CREATE_WEBHOOK_REQUEST = "CREATE_WEBHOOK_REQUEST";
export const CREATE_WEBHOOK_SUCCESS = "CREATE_WEBHOOK_SUCCESS";
export const CREATE_WEBHOOK_FAIL = "CREATE_WEBHOOK_FAIL";


export const GET_ACTIVE_WEBHOOKS_REQUEST = "GET_ACTIVE_WEBHOOKS_REQUEST";
export const GET_ACTIVE_WEBHOOKS_SUCCESS = "GET_ACTIVE_WEBHOOKS_SUCCESS";
export const GET_ACTIVE_WEBHOOKS_FAIL = "GET_ACTIVE_WEBHOOKS_FAIL";


export const DELETE_LEAD_REQUEST = "DELETE_LEAD_REQUEST";
export const DELETE_LEAD_SUCCESS = "DELETE_LEAD_SUCCESS";
export const DELETE_LEAD_FAIL = "DELETE_LEAD_FAIL";

export const DELETE_BULK_LEADS_REQUEST = "DELETE_BULK_LEADS_REQUEST";
export const DELETE_BULK_LEADS_SUCCESS = "DELETE_BULK_LEADS_SUCCESS";
export const DELETE_BULK_LEADS_FAIL = "DELETE_BULK_LEADS_FAIL";

// Activity logs Constant

export const GET_ACTIVITY_LOG_REQUEST = "GET_ACTIVITY_LOG_REQUEST";
export const GET_ACTIVITY_LOG_SUCCESS = "GET_ACTIVITY_LOG_SUCCESS";
export const GET_ACTIVITY_LOG_FAIL = "GET_ACTIVITY_LOG_FAIL";

export const CREATE_ACTIVITY_TEMPLATE_REQUEST = "CREATE_ACTIVITY_TEMPLATE_REQUEST";
export const CREATE_ACTIVITY_TEMPLATE_SUCCESS = "CREATE_ACTIVITY_TEMPLATE_SUCCESS";
export const CREATE_ACTIVITY_TEMPLATE_FAIL = "CREATE_ACTIVITY_TEMPLATE_FAIL";

export const READ_ACTIVITY_TEMPLATE_BY_ID_REQUEST = "READ_ACTIVITY_TEMPLATE_BY_ID_REQUEST";
export const READ_ACTIVITY_TEMPLATE_BY_ID_SUCCESS = "READ_ACTIVITY_TEMPLATE_BY_ID_SUCCESS";
export const READ_ACTIVITY_TEMPLATE_BY_ID_FAIL = "READ_ACTIVITY_TEMPLATE_BY_ID_FAIL";

export const UPDATE_ACTIVITY_TEMPLATE_REQUEST = "UPDATE_ACTIVITY_TEMPLATE_REQUEST";
export const UPDATE_ACTIVITY_TEMPLATE_SUCCESS = "UPDATE_ACTIVITY_TEMPLATE_SUCCESS";
export const UPDATE_ACTIVITY_TEMPLATE_FAIL = "UPDATE_ACTIVITY_TEMPLATE_FAIL";

export const DELETE_ACTIVITY_TEMPLATE_REQUEST = "DELETE_ACTIVITY_TEMPLATE_REQUEST";
export const DELETE_ACTIVITY_TEMPLATE_SUCCESS = "DELETE_ACTIVITY_TEMPLATE_SUCCESS";
export const DELETE_ACTIVITY_TEMPLATE_FAIL = "DELETE_ACTIVITY_TEMPLATE_FAIL";

export const READ_ACTIVITY_TEMPLATE_REQUEST = "READ_ACTIVITY_TEMPLATE_REQUEST";
export const READ_ACTIVITY_TEMPLATE_SUCCESS = "READ_ACTIVITY_TEMPLATE_SUCCESS";
export const READ_ACTIVITY_TEMPLATE_FAIL = "READ_ACTIVITY_TEMPLATE_FAIL";

// Tickets
export const GET_TICKETS_REQUEST = 'GET_TICKETS_REQUEST'
export const GET_TICKETS_SUCCESS = 'GET_TICKETS_SUCCESS'
export const GET_TICKETS_FAIL = 'GET_TICKETS_FAIL'

export const GET_TICKET_DETAIL_REQUEST = 'GET_TICKET_DETAIL_REQUEST'
export const GET_TICKET_DETAIL_SUCCESS = 'GET_TICKET_DETAIL_SUCCESS'
export const GET_TICKET_DETAIL_FAIL = 'GET_TICKET_DETAIL_FAIL'

export const CREATE_TICKET_REQUEST = 'CREATE_TICKET_REQUEST'
export const CREATE_TICKET_SUCCESS = 'CREATE_TICKET_SUCCESS'
export const CREATE_TICKET_FAIL = 'CREATE_TICKET_FAIL'

export const UPDATE_TICKET_STATUS_REQUEST = 'UPDATE_TICKET_STATUS_REQUEST'
export const UPDATE_TICKET_STATUS_SUCCESS = 'UPDATE_TICKET_STATUS_SUCCESS'
export const UPDATE_TICKET_STATUS_FAIL = 'UPDATE_TICKET_STATUS_FAIL'

export const ASSIGN_TICKET_REQUEST = 'ASSIGN_TICKET_REQUEST'
export const ASSIGN_TICKET_SUCCESS = 'ASSIGN_TICKET_SUCCESS'
export const ASSIGN_TICKET_FAIL = 'ASSIGN_TICKET_FAIL'

export const ADD_TICKET_COMMENT_REQUEST = 'ADD_TICKET_COMMENT_REQUEST'
export const ADD_TICKET_COMMENT_SUCCESS = 'ADD_TICKET_COMMENT_SUCCESS'
export const ADD_TICKET_COMMENT_FAIL = 'ADD_TICKET_COMMENT_FAIL'

export const GET_TICKET_DASHBOARD_REQUEST = 'GET_TICKET_DASHBOARD_REQUEST'
export const GET_TICKET_DASHBOARD_SUCCESS = 'GET_TICKET_DASHBOARD_SUCCESS'
export const GET_TICKET_DASHBOARD_FAIL = 'GET_TICKET_DASHBOARD_FAIL'

export const GET_MY_TICKETS_REQUEST = 'GET_MY_TICKETS_REQUEST'
export const GET_MY_TICKETS_SUCCESS = 'GET_MY_TICKETS_SUCCESS'
export const GET_MY_TICKETS_FAIL = 'GET_MY_TICKETS_FAIL'

// Email Template
export const GET_EMAIL_TEMPLATE_REQUEST = 'GET_EMAIL_TEMPLATE_REQUEST'
export const GET_EMAIL_TEMPLATE_SUCCESS = 'GET_EMAIL_TEMPLATE_SUCCESS'
export const GET_EMAIL_TEMPLATE_FAIL = 'GET_EMAIL_TEMPLATE_FAIL'

export const UPSERT_EMAIL_TEMPLATE_REQUEST = 'UPSERT_EMAIL_TEMPLATE_REQUEST'
export const UPSERT_EMAIL_TEMPLATE_SUCCESS = 'UPSERT_EMAIL_TEMPLATE_SUCCESS'
export const UPSERT_EMAIL_TEMPLATE_FAIL = 'UPSERT_EMAIL_TEMPLATE_FAIL'

export const DELETE_EMAIL_TEMPLATE_REQUEST = 'DELETE_EMAIL_TEMPLATE_REQUEST'
export const DELETE_EMAIL_TEMPLATE_SUCCESS = 'DELETE_EMAIL_TEMPLATE_SUCCESS'
export const DELETE_EMAIL_TEMPLATE_FAIL = 'DELETE_EMAIL_TEMPLATE_FAIL'

export const TOGGLE_REPORT_EMAIL_REQUEST = 'TOGGLE_REPORT_EMAIL_REQUEST'
export const TOGGLE_REPORT_EMAIL_SUCCESS = 'TOGGLE_REPORT_EMAIL_SUCCESS'
export const TOGGLE_REPORT_EMAIL_FAIL = 'TOGGLE_REPORT_EMAIL_FAIL'

export const TOGGLE_REPORT_PAGE6_REQUEST = 'TOGGLE_REPORT_PAGE6_REQUEST'
export const TOGGLE_REPORT_PAGE6_SUCCESS = 'TOGGLE_REPORT_PAGE6_SUCCESS'
export const TOGGLE_REPORT_PAGE6_FAIL = 'TOGGLE_REPORT_PAGE6_FAIL'

// Lead Erasure Rules
export const GET_LEAD_ERASURE_RULES_REQUEST = 'GET_LEAD_ERASURE_RULES_REQUEST';
export const GET_LEAD_ERASURE_RULES_SUCCESS = 'GET_LEAD_ERASURE_RULES_SUCCESS';
export const GET_LEAD_ERASURE_RULES_FAIL = 'GET_LEAD_ERASURE_RULES_FAIL';

export const ADD_LEAD_ERASURE_RULE_REQUEST = 'ADD_LEAD_ERASURE_RULE_REQUEST';
export const ADD_LEAD_ERASURE_RULE_SUCCESS = 'ADD_LEAD_ERASURE_RULE_SUCCESS';
export const ADD_LEAD_ERASURE_RULE_FAIL = 'ADD_LEAD_ERASURE_RULE_FAIL';

export const UPDATE_LEAD_ERASURE_RULE_REQUEST = 'UPDATE_LEAD_ERASURE_RULE_REQUEST';
export const UPDATE_LEAD_ERASURE_RULE_SUCCESS = 'UPDATE_LEAD_ERASURE_RULE_SUCCESS';
export const UPDATE_LEAD_ERASURE_RULE_FAIL = 'UPDATE_LEAD_ERASURE_RULE_FAIL';

export const DELETE_LEAD_ERASURE_RULE_REQUEST = 'DELETE_LEAD_ERASURE_RULE_REQUEST';
export const DELETE_LEAD_ERASURE_RULE_SUCCESS = 'DELETE_LEAD_ERASURE_RULE_SUCCESS';
export const DELETE_LEAD_ERASURE_RULE_FAIL = 'DELETE_LEAD_ERASURE_RULE_FAIL';

export const TOGGLE_LEAD_ERASURE_RULE_REQUEST = 'TOGGLE_LEAD_ERASURE_RULE_REQUEST';
export const TOGGLE_LEAD_ERASURE_RULE_SUCCESS = 'TOGGLE_LEAD_ERASURE_RULE_SUCCESS';
export const TOGGLE_LEAD_ERASURE_RULE_FAIL = 'TOGGLE_LEAD_ERASURE_RULE_FAIL';
